import api from '@/api'
import requestHelper from '@/utilities/requestHelper'

export default {
    state: ()=> ({
        cruiseSearchPage: setCruiseSearchPage({}),
        cruiseFilters: [],
        cruiseLists: {
            items: [],
            count: 0
        },
        filterRequest: {
            "hp": {
                "departures": [],
                "destinations": [],
                "sailDates": [],
                "sailDays": [],
                "shipCodes": [],
                "tags": []
            },
            "row": {
                "departures": [],
                "destinations": [],
                "sailDates": [],
                "sailDays": [],
                "shipCodes": [],
                "tags": []
            }
        },
        filterResponse: {
            "hp": {
                "departures": [],
                "destinations": [],
                "sailDates": [],
                "sailDays": [],
                "shipCodes": [],
                "tags": []
            },
            "row": {
                "departures": [],
                "destinations": [],
                "sailDates": [],
                "sailDays": [],
                "shipCodes": [],
                "tags": []
            }
        },
        cruiseDetail: {
            success: true,
            data: {},
            shipCode: '',
            sailDate: '',
        }
    }),
    actions: {
        GET_CRUISE_FILTERS: async({ commit }) => {
            const { success, data, errMsg } = await api.cruise.getCruiseFilter()
            if (!success) {
                console.error(errMsg)
                return Promise.reject()
              }
              if (data) {
                commit('GET_CRUISE_FILTERS', {
                    cruiseFilters: data
                })
              }
        },
        RESET_CRUISE_FILTERS: ({ commit })=> {
            commit('RESET_CRUISE_FILTERS')
        },
        SET_CRUISE_FILTERS: ({ commit }, { cruiseType, key, values}) => {
            commit('SET_CRUISE_FILTERS', { cruiseType, key, values })
        },
        INIT_CRUISE_FILTER_LIST: ({ commit }, { cruiseType, data}) => {
            commit('INIT_CRUISE_FILTER_LIST', { cruiseType, data})
        },
        REMOVE_CRUISE_FILTERS: ( { commit }, { cruiseType, key, values})=> {
            commit('REMOVE_CRUISE_FILTERS', { cruiseType, key, values })
        },
        RESET_DESTINATION_FILTERS: ({ commit }, { cruiseType })=> {
            commit('RESET_DESTINATION_FILTERS', { cruiseType })
        },
        CRUISE_SEARCH: ({ commit }, { data } ) => {
            return commit('CRUISE_SEARCH', { requestData: data})
        },
        GET_CRUISE_DETAIL: ( { commit, rootState}, { requestData }) => {
            return commit('GET_CRUISE_DETAIL', { requestData, rootState })
        }
    },
    mutations: {
        GET_CRUISE_FILTERS: (state, { cruiseFilters }) => {
            if (cruiseFilters) {
                state.cruiseFilters = cruiseFilters
            }
        },
        RESET_CRUISE_FILTERS: (state) => {
            state.filterRequest = {
                "hp": {
                    "departures": [],
                    "destinations": [],
                    "sailDates": [],
                    "sailDays": [],
                    "shipCodes": [],
                    "tags": []
                },
                "row": {
                    "departures": [],
                    "destinations": [],
                    "sailDates": [],
                    "sailDays": [],
                    "shipCodes": [],
                    "tags": []
                }
            }
            setCruiseFilterHandler(state, 'hp')
            setCruiseFilterHandler(state, 'row')
        },
        SET_CRUISE_FILTERS: (state, { cruiseType, key, values }) => {
            let filterRequest = state.filterRequest[cruiseType][key]
            values.forEach((value) => {
                if (!filterRequest.some(filter => filter.code == value.code)) {
                    filterRequest.push(value)
                }
            })
            state.filterRequest[cruiseType][key] = filterRequest
            setCruiseFilterHandler(state, cruiseType)
        },
        INIT_CRUISE_FILTER_LIST: (state, { cruiseType, data}) => {
            // 先初始化数据
            state.filterRequest = {
                "hp": {
                    "departures": [],
                    "destinations": [],
                    "sailDates": [],
                    "sailDays": [],
                    "shipCodes": [],
                    "tags": []
                },
                "row": {
                    "departures": [],
                    "destinations": [],
                    "sailDates": [],
                    "sailDays": [],
                    "shipCodes": [],
                    "tags": []
                }
            }
            data.forEach((item) => {
                let filterRequest = state.filterRequest[cruiseType][item.key]
                item.values.forEach((value) => {
                    if (!filterRequest.some(filter => filter.code == value.code)) {
                        filterRequest.push(value)
                    }
                })
            })
            setCruiseFilterHandler(state, cruiseType)
        },
        REMOVE_CRUISE_FILTERS: (state, { cruiseType, key, values }) => {
            let filterRequest = state.filterRequest[cruiseType][key]
            values.forEach((value) => {
                filterRequest = filterRequest.filter(item => !(item.code == value.code))
            })
            state.filterRequest[cruiseType][key] = filterRequest
            setCruiseFilterHandler(state, cruiseType)
        },
        RESET_DESTINATION_FILTERS: (state, { cruiseType }) => {
            state.filterRequest[cruiseType].destinations = []
            setCruiseFilterHandler(state, cruiseType)
        },
        SET_CRUISE_SEARCH_PAGE: (state, { data}) => {
            state.cruiseSearchPage = setCruiseSearchPage(data)
        },
        CRUISE_SEARCH: async (state, { requestData }) => {
            let request = requestHelper.generateCruiseSearchRequest(requestData, 'hp')
            const { success, data, errMsg } = await api.cruise.cruiseSearch(request)
            if (!success) {
                console.error(errMsg)
                return
            }
            state.cruiseLists = {
                items: data.cruises || [],
                count: data.count
            }
        },
        GET_CRUISE_DETAIL: async(state, { requestData }) => {
            const cruiseDetail = state.cruiseDetail;
            if (cruiseDetail.shipCode == requestData.shipCode && cruiseDetail.sailDate == requestData.sailDate) {
                return;
            }
            state.cruiseDetail.shipCode = requestData.shipCode
            state.cruiseDetail.sailDate = requestData.sailDate
            const { success, data, errMsg } = await api.cruise.getCruiseDetail(requestData);
            if (!success) {
                console.error(errMsg);
            }
            state.cruiseDetail = { success, data, shipCode: requestData.shipCode, sailDate: requestData.sailDate };
            
        },
        SET_CRUISE_DETAIL_SAILING: (state, { shipCode, sailDate }) => {
            state.cruiseDetail.shipCode = shipCode
            state.cruiseDetail.sailDate = sailDate
        },
        SET_CRUISE_DETAIL: (state, { success, data}) => {
            state.cruiseDetail.success = success
            state.cruiseDetail.data = data
        }
    }
}

async function setCruiseFilterHandler(state, cruiseType) {
    const request = requestHelper.generateCruiseSearchRequest(state.filterRequest[cruiseType], cruiseType)
    const { success, data, errMsg } = await api.cruise.setCruiseFilter(request)
    if (!success) {
        console.error(errMsg)
    }
    state.filterResponse[cruiseType] = data
}


function setCruiseSearchPage(data) {
    return {
        "cruiseFilters": data.cruiseFilters || [],
        "months": data.months || [],
        "tags": data.tags || [],
        "pcPopupImage": data.pcPopupImage || {},
        "topSearch": data.topSearch || [],
        "seoViewModel": data.seoViewModel || {},
        "cruiseHomeBanner": {
            "imageUrl": data.homeBannerImg || "",
            "link": data.homeBannerUrl || ""
        },
        "cruiseTopSells": data.cruiseTopSells || [],
        "cruiseSearchBanners": data.cruiseSearchBanners || [],
        "homeBanner": {
            "image": data.homeBannerImg || "",
            "url": data.homeBannerUrl || ""
        }

    }
}